import { CommnunicationPreferencesSnapshotModel } from "./unified-profile/CommunicationPreferenceSnapshotModel";
import { ConditionManagementSnapshotModel } from "./unified-profile/ConditionManagementSnapshotModel";
import { LowBloodSugarSnapshotModel } from "./unified-profile/LowBloodSugarSnapshotModel";
import { HighBloodSugarSnapshotModel } from "./unified-profile/HighBloodSugarSnapshotModel";
import { DoNotDisturbHoursSnapshotModel } from "./unified-profile/DoNotDisturbHoursSnapshotModel";
import { MentalHealthSnapshotModel } from "./unified-profile/MentalHealthSnapshotModel";

export class SnapshotModelFactory {
  static for(screenName) {
    switch (screenName) {
      case "CommunicationPreferences":
        return new CommnunicationPreferencesSnapshotModel();
      case "ConditionManagement":
        return new ConditionManagementSnapshotModel();
      case "LowBloodSugarThreshold":
        return new LowBloodSugarSnapshotModel();
      case "HighBloodSugarThreshold":
        return new HighBloodSugarSnapshotModel();
      case "DoNotDisturbHours":
        return new DoNotDisturbHoursSnapshotModel();
      case "MentalHealth":
        return new MentalHealthSnapshotModel();
      default:
        break;
    }
  }
}
